import { customStorageEventName } from '@vueuse/core';

export const SELECTED_BRANCH_STORAGE_KEY = 'selectedBranchId';

// The user and permission stores read this key through vueuse's useStorage, which only learns of
// a change from its own ref, from the window `storage` event (browsers fire it for OTHER tabs
// only) or from its `vueuse-storage` custom event. A raw setItem in this tab leaves those refs
// stale, so every write announces itself the way vueuse's own write does, on the channel vueuse
// listens to for this storage: `storage` for a real Storage, the custom event for a mocked one.
const announceWrite = (oldValue: string | null, newValue: string | null): void => {
  const payload = { key: SELECTED_BRANCH_STORAGE_KEY, oldValue, newValue, storageArea: localStorage };
  window.dispatchEvent(
    localStorage instanceof Storage
      ? new StorageEvent('storage', payload)
      : new CustomEvent(customStorageEventName, { detail: payload })
  );
};

export const getCurrentSelectedBranch = (): string | null => {
  return localStorage.getItem(SELECTED_BRANCH_STORAGE_KEY);
};

export const setCurrentSelectedBranch = (branchId: string): void => {
  const oldValue = localStorage.getItem(SELECTED_BRANCH_STORAGE_KEY);
  localStorage.setItem(SELECTED_BRANCH_STORAGE_KEY, branchId);
  if (oldValue !== branchId) {
    announceWrite(oldValue, branchId);
  }
};

export const clearSelectedBranch = (): void => {
  const oldValue = localStorage.getItem(SELECTED_BRANCH_STORAGE_KEY);
  localStorage.removeItem(SELECTED_BRANCH_STORAGE_KEY);
  if (oldValue !== null) {
    announceWrite(oldValue, null);
  }
};
